/**
 * @class
 * @extends PIXI.Container
 * @memberOf P3
 */
export default class Scene extends PIXI.Container {
    constructor() {
        super();

        /**
         * @member {object} signals
         * @member {signals.Signal} signals.next
         * @member {signals.Signal} signals.previous
         * @member {signals.Signal} signals.home
         * @member {signals.Signal} signals.pause
         */
        this.signals = {
            next: new signals.Signal(),
            previous: new signals.Signal(),
            home: new signals.Signal(),
            pause: new signals.Signal()
        };

        /**
         * @member {boolean} - The scene has finished loading its required manifest.
         */
        this.loaded = false;

        /**
         * @member {boolean} - The scene is always updated regardless of its place in the stack.
         */
        this.alwaysUpdate = false;

        /**
         * @member {boolean} - The scene will call appear automatically.
         */
        this.autoAppear = true;

        /**
         * @member {TimelineMax}
         * @private
         */
        this._timeline = new TimelineMax();
    }

    /**
     * @returns {Scene}
     */
    preloader() {
        return new Scene();
    }

    /**
     * @returns {Array}
     */
    load() {
        return [];
    }

    unload() {
        // override
    }

    /**
     * This method is called when a scene is initialized.
     */
    init() {
        // override
    }

    /**
     * This method is called when a scene is destroyed.
     *
     * @param options
     * @param [options.children=false]
     * @param [options.texture=false]
     * @param [options.baseTexture=false]
     */
    destroy(options) {
        this.signals.next.dispose();
        this.signals.previous.dispose();
        this.signals.home.dispose();
        this.signals.pause.dispose();

        super.destroy(options);
    }

    /**
     * This method is called when the device dimensions are changed.
     */
    resize() {
        // override
    }

    /**
     * This method is called when the scene is 'top' of the stack.
     */
    update() {
        // override
    }

    /**
     * This method is called when the scene is shown for the first time.
     */
    appear() {
        this.animateIn();
    }

    /**
     * This method is called when the scene is shown - regardless of actual visibility.
     */
    show() {
    }

    /**
     * This method is called when the scene is hidden - regardless of actual visibility.
     */
    hide() {
    }

    /**
     * @param {function} [callback]
     * @param {*} [scope]
     */
    animateIn(callback, scope) {
    }

    /**
     * @param {function} [callback]
     * @param {*} [scope]
     */
    animateOut(callback, scope) {
    }

    /**
     * @param {...TweenMax|TweenLite|TimelineMax|TimelineLite} tween - The tween(s) to add to the scene.
     * @returns {TweenMax|TweenLite|TimelineMax|TimelineLite} The first tween that was added.
     */
    addTween(tween) {
        const len = arguments.length;
        if (len > 1) {
            for (let i = 0; i < len; ++i) {
                this.addTween(arguments[tween]);
            }
        } else {
            this._timeline.add(tween, {position: 0});
        }
        return tween;
    }

    /**
     * @param {...TweenMax|TweenLite|TimelineMax|TimelineLite} tween - The tween(s) to remove from the scene.
     * @returns {TweenMax|TweenLite|TimelineMax|TimelineLite} The first tween that was removed.
     */
    removeTween(tween) {
        const len = arguments.length;
        if (len > 1) {
            for (let i = 0; i < len; ++i) {
                this.removeTween(arguments[tween]);
            }
        } else {
            this._timeline.remove(tween);
        }
        return tween;
    }

    /**
     * @returns {TimelineMax}
     */
    get timeline() {
        return this._timeline;
    }
}